<ng-template [ngIf]="filterable">
  <label style="width: 200px; display: inline-block">
    Filtro:
  </label>
  <input pInputText type="text" (input)="filterItems($event)">
</ng-template>
<br><br>
<ng-template [ngIf]="isGrouped" [ngIfElse]="notGroupedItem">
  <p-accordion [multiple]="true">
    <p-accordionTab [header]="getAccordionTitle(groupName)" *ngFor="let groupName of getGroupNames()">
      <div class="grid">
        <div [class]="gridColumnClass" *ngFor="let item of getItemsFromGroupName(groupName)">
          <p-toggleButton [ngModel]="isSelected(item)"
                          (ngModelChange)="setSelected(item, $event)"
                          [onLabel]="getLabel(item)"
                          [offLabel]="getLabel(item)"></p-toggleButton>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
</ng-template>
<ng-template #notGroupedItem>
  <div class="grid">
    <div [class]="gridColumnClass" *ngFor="let item of getSortedItems()">
      <p-toggleButton [ngModel]="isSelected(item)"
                      (ngModelChange)="setSelected(item, $event)"
                      [onLabel]="getLabel(item)"
                      [offLabel]="getLabel(item)"></p-toggleButton>
    </div>
  </div>
</ng-template>
